<template>
  <div class="navtab">
    <div class="navtab__box">
      <p class="navtab__box--title">
        Experiences with soul
      </p>
      <div v-for="experience in experiencesList" :key="experience.id">
        <app-link :id="experience.linkId" :type="experience.linkType" class="navtab__box--list link-unstyle">
          {{ experience.name }}
        </app-link>
      </div>
    </div>
    <div class="navtab__box">
      <!-- <p class="navtab__box--title">
        Unique experiences
      </p>
      <div v-for="experience in uniqueExperiencesList" :key="experience.id">
        <app-link :id="experience.linkId" :type="experience.linkType" class="navtab__box--list link-unstyle">
          {{ experience.name }}
        </app-link>
      </div> -->
    </div>
    <div class="navtab__box image">
      <img src="../../../assets/img/src/navbar/experiences-tab/featured-image.jpg" class="lazyload" width="432" height="359" alt="Experiences Featured Image">
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL,
      experiencesList: [
        {
          id: 1,
          name: 'Top Mediterranean adventures',
          linkType: 'page',
          linkId: 1032,
        },
        {
          id: 2,
          name: 'Mediterranean gastronomy',
          linkType: 'page',
          linkId: 1033,
        },
        {
          id: 3,
          name: 'Learn new skills',
          linkType: 'page',
          linkId: 1036,
        },
        {
          id: 4,
          name: 'Cultural holidays and activities',
          linkType: 'page',
          linkId: 1037,
        },
        {
          id: 5,
          name: 'Water sports and activities',
          linkType: 'page',
          linkId: 1034,
        },
        {
          id: 6,
          name: 'Wine-tasting experiences',
          linkType: 'page',
          linkId: 1035,
        },
        {
          id: 7,
          name: 'Explore all',
          linkType: 'page',
          linkId: 40,
        },
      ],
      uniqueExperiencesList: [
        {
          id: 1,
          name: 'Cookery retreat with C. Puglisi',
          linkType: 'page',
          linkId: 840,
        },
        {
          id: 2,
          name: 'Cookery retreat with Michael Tusk',
          linkType: 'page',
          linkId: 1143,
        },
        // {
        //   id: 3,
        //   name: 'Weddings',
        //   linkType: 'collection',
        //   linkId: 230,
        // },
      ],
    };
  },
  computed: {
    // isSearchTouched() {
    //   return this.$store.getters.getSearchTouch;
    // },
  },
  methods: {
    getAppLinkByID(pageID, ptype) {
      return this.$store.getters['applinks/getLink'](ptype, pageID).url;
    },
  },
};
</script>
